module.exports = __webpack_public_path__ + "3fb708ba4c603515243452b9dba17771.png";